import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import SwitchContainer from "../../common/SwitchContainer";

export default function CustomBrandPersonaVoiceToneToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  return (
    <SwitchContainer
      title="Custom Brand Persona / Voice / Tone"
      tooltip="Describe your brand persona, voice, and tone."
      enabled={Boolean(values?.useCustomBrandPersonaVoiceTone)}
      setEnabled={() =>
        setFieldValue(
          "useCustomBrandPersonaVoiceTone",
          !values?.useCustomBrandPersonaVoiceTone
        )
      }
      className="mb-6"
    />
  );
}
